<div class="flex" [ngClass]="{'sidebar-active': app.sidebarActive}">
    <div class="sidebar-next-right-block">
        <partner-marketing-promotions *ngIf="activeMenu === menuEnum.AllPromotions" [menuPermissionActive]="menuPermissionActive"></partner-marketing-promotions>
    </div>
</div>
